module.exports = __webpack_public_path__ + "img/sapphire.44b2299.webp";